<template>
  <div class="ma-3">
    <h1 style="font-size: xx-large;margin-top: 80px; line-height: 35px; font-weight: bold;"
      :style="{ color: $ajustes.colorTexto2 }">NUESTROS CURSOS</h1>
    <h1 style="font-size:large; line-height: 35px; font-weight: normal;" :style="{ color: $ajustes.colorTexto2 }">
      Formarte es prepararte</h1>
    <v-row class="pt-2 center" v-if="cursos.length > 0">
      <v-col class="ma-0 pa-2" v-for="curso in cursosDestacados" :key="curso.id" lg="3" md="4" sm="6" cols="12">
        <v-container class="pa-1" style="align-items: center;align-items: center;">
          <curso :propCurso="curso" @propAccion="activarFormulario" />
        </v-container>
      </v-col>
    </v-row>
    <h2 v-else class="center">
      <br>
      {{ datosMensaje }}
    </h2>
    <v-dialog v-model="formularioDialogo" width="400px">
      <formulario :propId="infoFormulario.id" :propIndicacion="infoFormulario.indicacion"
        :propAsunto="infoFormulario.asunto" @propCerrarFormulario="formularioDialogo = false" />
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import curso from "@/components/template/curso";
import formulario from "@/components/template/formulario";


export default {
  components: {
    curso,
    formulario
  },
  metaInfo() {
    return {
      title: "Cursos y Talleres",
      titleTemplate: "%s | INSEG",
      meta: [
        {
          name: "description",
          content: "Descubre nuestros cursos y talleres en Seguridad Global y Transporte, INSEG Ecuador. Formación técnica y profesional para tu crecimiento."
        }
      ]
    }
  },
  data() {
    return {
      datosMensaje: "Buscando...",
      cursos: [],
      showMenu: true,
      formularioDialogo: false,
      infoFormulario: { id: "", asunto: "", indicacion: "" },
      show: {
        responsible: "",
      },

    };
  },
  mounted() {

    this.obtenerCursos()
  },
  created() {

  },
  methods: {
    async obtenerCursos() {
      await axios.get("/obtener_cursos")
        .then((response) => {
          if (response) {
            this.cursos = response.data.data
          }
        })
        .catch(() => {
          this.datosMensaje = "No hay cursos disponibles"
        });
      this.loading = false
    },
    activarFormulario(id, titulo) {
      this.infoFormulario.id = id
      this.infoFormulario.indicacion = "¿Estas interesado en participar en el curso o taller de: " + titulo + "?"
      this.infoFormulario.asunto = "Interesado en " + titulo
      this.formularioDialogo = true
    },

  },
  computed: {
    cursosDestacados() {
      return this.cursos.filter(curso => curso.habilitado);
    }
  },
  beforeDestroy() {
  },
};
</script>

<style scoped>
.centered-input>>>input {
  text-align: center;
}
</style>